import uniqBy from 'lodash/uniqBy';

import type { ActivityRecord } from '@appTypes/esb';
import { activityTypeIds } from '@modules/shared/constants';
import personNameBuilder from '@modules/utils/personNameBuilder';

import { isScoutbookImport } from '../utils';

export function transformActiviy(activity: ActivityRecord) {
  return {
    ...activity,
    isJTE:
      activity.activityTypeId === activityTypeIds.SERVICE_PROJECTS &&
      !isScoutbookImport(activity.createdBy),
    registeredAdults: activity.registeredAdults.map(adult => ({
      ...adult,
      isAdult: !adult.isYouth,
      personShortFullName: personNameBuilder.short(adult),
    })),
    registeredYouths: activity.registeredYouths.map(youth => ({
      ...youth,
      isAdult: !youth.isYouth,
      personShortFullName: personNameBuilder.short(youth),
    })),
    totalAdults: uniqBy(activity.registeredAdults, adult => adult.userId)
      .length,
    totalYouths: uniqBy(activity.registeredYouths, youth => youth.userId)
      .length,
  };
}
